import { render, staticRenderFns } from "./WholeNetworkPersonNewsList.vue?vue&type=template&id=14d54d44&scoped=true"
import script from "./WholeNetworkPersonNewsList.vue?vue&type=script&lang=js"
export * from "./WholeNetworkPersonNewsList.vue?vue&type=script&lang=js"
import style0 from "./WholeNetworkPersonNewsList.vue?vue&type=style&index=0&id=14d54d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d54d44",
  null
  
)

export default component.exports